export default __webpack_public_path__ + "static/media/dr-hema-h-r.75a6c7ed.png";